import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** map pin, location. Decorative line icon; always pair with a visible text label. */
export function MapPinIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M12 21.2s-6.6-5.6-6.6-10.4a6.6 6.6 0 0 1 13.2 0c0 4.8-6.6 10.4-6.6 10.4z" />
      <circle cx="12" cy="10.6" r="2.4" />
    </IconSvg>
  )
}
